import axios from 'axios';

/**
 *  getJSONresponse get method
 *  to the Json from blob storage */
export default async function getJSONresponse(url) {
  let json = [];
  await axios.get(url).then((response) => {
    if (response.data) {
      json = response.data;
    }
  }).catch((err) => {
    console.log('getJSON blob error', err); // eslint-disable-line no-console
  });
  return json;
}
